/**
 * 모니터링 서비스 (관리자 전용)
 * - SSL 인증서, 업타임, 디스크, DB, 배포, 알림, 보안 대시보드
 */

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.ilouli.com';
const TOKEN_KEY = 'ilouli_token';

const getToken = () => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === TOKEN_KEY) return decodeURIComponent(value);
  }
  try {
    const backupToken = localStorage.getItem(`${TOKEN_KEY}_backup`);
    if (backupToken) return backupToken;
  } catch (e) {}
  return null;
};

const getHeaders = () => {
  const token = getToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

const fetchApi = async (url) => {
  const response = await fetch(url, { headers: getHeaders(), credentials: 'include' });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};

export const getServiceHealth = () => fetchApi(`${API_BASE}/api/admin/monitoring/services/health`);
export const getSSLCertificates = () => fetchApi(`${API_BASE}/api/admin/monitoring/ssl`);
export const getDiskHistory = (days = 30) => fetchApi(`${API_BASE}/api/admin/monitoring/disk/history?days=${days}`);
export const getDbHistory = (days = 30) => fetchApi(`${API_BASE}/api/admin/monitoring/db/history?days=${days}`);
export const getUptime = (hours = 24) => fetchApi(`${API_BASE}/api/admin/monitoring/uptime?hours=${hours}`);
export const getErrorLogs = (lines = 50, service = null) => {
  let url = `${API_BASE}/api/admin/monitoring/error-logs?lines=${lines}`;
  if (service) url += `&service=${service}`;
  return fetchApi(url);
};
export const getDeployHistory = (repo = null, limit = 20) => {
  let url = `${API_BASE}/api/admin/deployment/history?limit=${limit}`;
  if (repo) url += `&repo=${repo}`;
  return fetchApi(url);
};
export const triggerDeploy = async (repoName) => {
  const response = await fetch(`${API_BASE}/api/admin/deployment/trigger/${repoName}`, {
    method: 'POST', headers: getHeaders(), credentials: 'include'
  });
  if (!response.ok) throw new Error(`HTTP ${response.status}`);
  return response.json();
};
export const getAlerts = (unreadOnly = false) => fetchApi(`${API_BASE}/api/admin/alerts?unread_only=${unreadOnly}`);
export const getUnreadCount = () => fetchApi(`${API_BASE}/api/admin/alerts/unread-count`);
export const markAlertRead = async (id) => {
  const response = await fetch(`${API_BASE}/api/admin/alerts/${id}/read`, {
    method: 'PUT', headers: getHeaders(), credentials: 'include'
  });
  return response.json();
};
export const markAllRead = async () => {
  const response = await fetch(`${API_BASE}/api/admin/alerts/read-all`, {
    method: 'PUT', headers: getHeaders(), credentials: 'include'
  });
  return response.json();
};
export const getAuditLog = (limit = 50) => fetchApi(`${API_BASE}/api/admin/analytics/audit-log?limit=${limit}`);
export const getSecurityDashboard = () => fetchApi(`${API_BASE}/api/admin/analytics/security`);

export default {
  getServiceHealth, getSSLCertificates, getDiskHistory, getDbHistory, getUptime, getErrorLogs,
  getDeployHistory, triggerDeploy, getAlerts, getUnreadCount, markAlertRead, markAllRead,
  getAuditLog, getSecurityDashboard
};
